import { PhoneField, validatePhoneNumber } from '@boltenergy-be/design-system'
import { useTranslation } from 'react-i18next'
import { PhoneProps } from './types.ts'
import { Controller, useFormContext } from 'react-hook-form'

const Phone = ({ hookFormIdentifier, required = true, ...props }: PhoneProps) => {
  // i18n
  const { t } = useTranslation('validation')

  // Constants
  const fieldKey = hookFormIdentifier || 'phoneMobile'

  // React Hook Form
  const { control } = useFormContext()

  return (
    <Controller
      {...{ control }}
      name={fieldKey}
      rules={{
        required: required ? t(($) => $.required) : false,
        validate: (value: string) => {
          // Validation not needed if not required with no value
          if (!required && !value) return true
          return validatePhoneNumber(value || '')?.valid || t(($) => $.invalid.phone)
        }
      }}
      render={({ field, formState }) => (
        <PhoneField
          {...props}
          ref={field.ref}
          name={field.name}
          value={field.value}
          onChange={field.onChange}
          onBlur={field.onBlur}
          error={formState.errors?.[fieldKey]?.message as string | undefined}
        />
      )}
    />
  )
}

export default Phone
